import type { SxProps } from '@mui/material';
import { Box, CircularProgress } from '@mui/material';
import type { FC } from 'react';

interface Props {
  size?: string | number;
  sx?: SxProps;
}

export const Spinner: FC<Props> = ({ size, sx }) => {
  return <CircularProgress size={size} sx={sx} />;
};

export const HorizontalMiddleSpinner: FC<Props> = ({ size }) => {
  return (
    <Box
      sx={{
        alignSelf: 'center',
        display: 'flex',
        justifyContent: 'center',
        justifySelf: 'center',
        m: 3,
      }}
    >
      <Spinner size={size} />
    </Box>
  );
};

export const MiddleSpinner: FC<Props> = ({ size }) => {
  return (
    <Box
      sx={{
        bottom: 0,
        display: 'grid',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
      }}
    >
      <HorizontalMiddleSpinner size={size} />
    </Box>
  );
};
